import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
    Avatar,
    ButtonBase,
} from '@material-ui/core';
import PropTypes from 'prop-types';



class AnchorItem extends React.Component {

    render() {
        const { classes, name, avatar, fans, sbusb } = this.props;
        return (
            <ButtonBase className={classes.bttonBase} onClick={() => this.props.onClick && this.props.onClick()} >
                <Grid container direction='column' alignItems='center' style={{ width: '100vw' }}>
                    <Grid container direction='row' justifyContent='space-between' alignItems='center' style={{ width: '100vw', marginTop: 16 }}>
                        <Grid container direction='row' alignItems='center' style={{ flex: 1, paddingLeft: 8 }}>
                            <Avatar src={avatar} className={classes.avatar}></Avatar>
                            <Grid container direction='column' alignItems='flex-start' style={{ flex: 1, marginLeft: 8 }}>
                                <Typography noWrap className={classes.title}>{name}</Typography>
                                <Typography noWrap className={classes.fans}>{'粉丝:' + fans}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container justifyContent='center' alignItems='center' className={sbusb ? classes.subtitle1 : classes.subtitle}>
                            <Typography className={sbusb ? classes.titleFont : classes.titleFont1}>{sbusb ? '已关注' : '关注'}</Typography>
                        </Grid>
                    </Grid>
                    <Grid style={{ width: 'calc(100vw - 16px)', height: 1, backgroundColor: '#F7F7F7', marginTop: 16 }}></Grid>
                </Grid>

            </ButtonBase>
        );
    }
}

AnchorItem.propTypes = {
    name: PropTypes.string.isRequired,
    avatar: PropTypes.string.isRequired,
    fans: PropTypes.number.isRequired,
    sbusb: PropTypes.bool.isRequired,
}

export default withStyles((theme) => ({
    avatar: {
        height: 50,
        width: 50,
    },
    title: {
        color: theme.palette.common.default,
        fontSize: 12,
        margin: theme.spacing(0.5, 0, 0.5, 0),
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        maxWidth: 60
    },
    fans: {
        color: '#878787',
        fontSize: 12,
        margin: theme.spacing(0.5, 0, 0.5, 0),
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        maxWidth: 60
    },
    subtitle: {
        backgroundColor: '#FFF',
        borderRadius: 12.5,
        textAlign: 'center',
        border: 'solid 1px ' + theme.palette.primary.main,
        height: 25,
        width: 60,
        marginRight: 8,
    },
    subtitle1: {
        backgroundColor: '#FFF',
        borderRadius: 12.5,
        textAlign: 'center',
        border: 'solid 1px #E2E2E2',
        height: 25,
        width: 60,
        marginRight: 8,
    },
    titleFont: {
        color: '#878787',
        fontSize: 12,
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(0, 0, 0, 0),
    },
    titleFont1: {
        color: theme.palette.primary.main,
        fontSize: 12,
        margin: theme.spacing(0, 0, 0, 0),
        padding: theme.spacing(0, 0, 0, 0),
    },
    bttonBase: {
        margin: theme.spacing(0, 0, 0, 0),
    }

}))(AnchorItem);